module.exports = __webpack_public_path__ + "img/Question.a57b618.svg";